<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
   :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_VARIETY_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.adminContext.variety;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(variety) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_VARIETY_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(variety, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateVariety.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_VARIETY_QUERY = gql `
  query ($id: ID!) {
    adminContext {
      variety(id: $id) {
        id
        name
        title
        subCultureId
        subCulture{
          id
          name
          additionalInfo
        }
        validations
      }      
    } 
    globalContext {      
      allSubCultures{
        id
        name
        additionalInfo 
      }
    }
  }
`;

const UPDATE_VARIETY_MUTATION = gql `
  mutation($input: VarietyUpdateInputObject!) {
    updateVariety(input: $input) {
      variety {
        id
        name
        title
        subCultureId        
      }
      errors
    }
  }
`;

</script>

<style scoped></style>